import React from 'react';

import './Loading.css';

const imageKegL = '../../images/keg-size-l.png';

export const Loading = () => {
	return (
		<div className="loading">
			<div className="shaker">
				<img alt="Loading..." src={imageKegL} />
			</div>
			<p className="message">Loading...</p>
		</div>
	);
};